import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faArrowRight,
  faEnvelope,
  faLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import "../assets/css/ModernPages.css";
import "../assets/css/SocialLinks.css";

const ContactPage = () => {
  const [searchParams] = useSearchParams();
  const [sent, setSent] = useState(false);
  const [formType, setFormType] = useState(
    searchParams.get("type") === "employer" ? "employer" : "job-seeker",
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    setSent(true);
  };

  return (
    <main className="modern_page inner_page contact_page">
      <SiteHeader activePage="contact" />

      <section className="contact_layout shell">
        <div className="contact_intro">
          <Link to="/" className="back_link">
            <FontAwesomeIcon icon={faArrowLeft} /> Back to home
          </Link>
          <p className="eyebrow">
            <span /> Contact Staffing Mart
          </p>
          <h1>
            Let’s start with
            <br />
            <em>what you need.</em>
          </h1>
          <p className="inner_lede">
            Tell us what the next step looks like. We’ll bring the right
            questions, people, and possibilities to the conversation.
          </p>
          <div className="contact_details">
            <a href="tel:+919081699700">
              <FontAwesomeIcon icon={faPhone} />
              <span>
                <small>Call us</small>+91 90816 99700
              </span>
            </a>
            <a href="mailto:mdstaffingmart@gmail.com">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>
                <small>Email us</small>hrm.staffingmart@gmail.com
              </span>
            </a>
            <div>
              <FontAwesomeIcon icon={faLocationDot} />
              <span>
                <small>Visit us</small>Morabhagal, Surat
              </span>
            </div>
          </div>
          <a
            className="whatsapp_link"
            href="https://wa.me/919081699700"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faWhatsapp} /> Message us on WhatsApp
          </a>
          <div className="contact_social_links">
            <a
              href="https://www.instagram.com/staffingmartofficial/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} /> Instagram
            </a>
            <a
              href="https://www.linkedin.com/company/staffing-mart"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
            </a>
          </div>
        </div>

        <div className="contact_form_panel">
          {sent ? (
            <div className="success_state">
              <div className="success_mark">
                <FontAwesomeIcon icon={faArrowRight} />
              </div>
              <p className="eyebrow">
                <span /> Message received
              </p>
              <h2>
                We’ll be in touch
                <br />
                <em>very soon.</em>
              </h2>
              <p>
                Thanks for reaching out to Staffing Mart. Our team will review
                your note and contact you shortly.
              </p>
              <button
                className="text_action"
                type="button"
                onClick={() => setSent(false)}
              >
                Send another message <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p className="form_kicker">I’m reaching out as a</p>
              <div className="form_switch">
                <button
                  type="button"
                  className={formType === "employer" ? "selected" : ""}
                  onClick={() => setFormType("employer")}
                >
                  An employer
                </button>
                <button
                  type="button"
                  className={formType === "job-seeker" ? "selected" : ""}
                  onClick={() => setFormType("job-seeker")}
                >
                  A job seeker
                </button>
              </div>
              <label>
                Your name
                <input
                  required
                  name="name"
                  placeholder="How should we call you?"
                />
              </label>
              <label>
                Email address
                <input
                  required
                  type="email"
                  name="email"
                  placeholder="you@company.com"
                />
              </label>
              <label>
                {formType === "employer"
                  ? "Tell us about the role"
                  : "Tell us about your next move"}
                <textarea
                  required
                  name="message"
                  rows="4"
                  placeholder="A few details will help us prepare..."
                />
              </label>
              <button className="primary_action form_submit" type="submit">
                Send enquiry <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </form>
          )}
        </div>
      </section>
      <SiteFooter />
    </main>
  );
};

export default ContactPage;
